
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"5.97","y":"1","fill":"#000","fill-opacity":".87","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"15.02","y":"1","fill":"#000","fill-opacity":".87","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"20.1","height":"5.53","x":"1.95","y":"3.9","fill":"#FAB4CD","fill-rule":"nonzero","rx":"1.32"}}),_c('rect',{attrs:{"width":"20.1","height":"19.1","x":"1.95","y":"3.9","stroke":"#000","rx":"1.96"}}),_c('path',{attrs:{"stroke":"#000","d":"M1.95 9.43h20.1"}}),_c('path',{attrs:{"fill":"#FFC511","fill-rule":"nonzero","d":"M12 16c1.257 0 2.275-1.006 2.275-2.25S13.257 11.5 12 11.5s-2.275 1.006-2.275 2.25S10.743 16 12 16zm-4.55-.643c.717 0 1.3-.576 1.3-1.286 0-.709-.583-1.285-1.3-1.285-.717 0-1.3.576-1.3 1.285 0 .71.583 1.286 1.3 1.286zm9.1 0c.717 0 1.3-.576 1.3-1.286 0-.709-.583-1.285-1.3-1.285-.717 0-1.3.576-1.3 1.285 0 .71.583 1.286 1.3 1.286zm1.3 3.214c.36 0 .65-.287.65-.642v-.643c0-.71-.583-1.286-1.3-1.286h-1.3c-.357 0-.68.143-.916.374a2.934 2.934 0 011.525 2.197h1.341zm-10.361 0a2.944 2.944 0 011.527-2.197A1.305 1.305 0 008.1 16H6.8c-.717 0-1.3.577-1.3 1.286v.643c0 .355.29.642.65.642h1.339zm7.436 1.929a.97.97 0 00.975-.964v-.579c0-1.278-1.048-2.314-2.34-2.314h-.169c-.422.2-.891.321-1.391.321s-.967-.12-1.391-.321h-.169c-1.292 0-2.34 1.036-2.34 2.314v.579a.97.97 0 00.975.964h5.85z"}})])])
          )
        }
      }
    